import { styled, alpha, type Theme } from '@mui/material/styles';
import { Box, Card, Button, Avatar } from '@mui/material';

export const StyledDialog = {
  PaperProps: {
    sx: {
      height: '90vh',
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: '0 20px 60px rgba(2, 6, 23, 0.18)',
    },
  },
};

export const HeaderBox = styled(Box)(({ theme }) => ({
  padding: '18px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const dashboardCard = (theme: Theme) => ({
  borderRadius: 12,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.2s ease',
  '&:hover': {
    boxShadow:
      theme.palette.mode === 'dark'
        ? `0 0 0 1px ${alpha(theme.palette.primary.main, 0.35)}`
        : '0 4px 12px rgba(0, 0, 0, 0.12)',
  },
});

export const SectionBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.4 : 0.25)}`,
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
  boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 6px 20px rgba(2,6,23,0.06)',
  backgroundColor: theme.palette.background.paper,
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  background:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.info.main, 0.14)
      : 'linear-gradient(90deg, rgba(6,182,212,0.10) 0%, rgba(6,182,212,0.04) 100%)',
  borderBottom: `1px solid ${alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.35 : 0.25)}`,
}));

export const PaymentsBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.4 : 0.25)}`,
  borderRadius: 8,
  overflow: 'hidden',
  marginBottom: 16,
  backgroundColor: theme.palette.background.paper,
}));

export const PaymentsHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  background:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.success.main, 0.14)
      : 'linear-gradient(90deg, rgba(16,185,129,0.10) 0%, rgba(16,185,129,0.04) 100%)',
  borderBottom: `1px solid ${alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.35 : 0.25)}`,
}));

export const RefundsBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.4 : 0.25)}`,
  borderRadius: 8,
  overflow: 'hidden',
  marginBottom: 16,
  backgroundColor: theme.palette.background.paper,
}));

export const RefundsHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  background:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.error.main, 0.14)
      : 'linear-gradient(90deg, rgba(239,68,68,0.10) 0%, rgba(239,68,68,0.04) 100%)',
  borderBottom: `1px solid ${alpha(theme.palette.error.main, theme.palette.mode === 'dark' ? 0.35 : 0.25)}`,
}));

export const DashboardCardBlue = styled(Card)(({ theme }) => ({
  ...dashboardCard(theme),
}));

export const DashboardCardGreen = styled(Card)(({ theme }) => ({
  ...dashboardCard(theme),
}));

export const DashboardCardRed = styled(Card)(({ theme }) => ({
  ...dashboardCard(theme),
}));

export const SectionAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.22 : 0.18),
  color: theme.palette.mode === 'dark' ? theme.palette.info.light : theme.palette.info.dark,
  width: 26,
  height: 26,
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  minWidth: '120px',
  padding: '9px 18px',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.action.hover : theme.palette.grey[50],
  border: 'none',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.12)
        : theme.palette.grey[100],
    color: theme.palette.text.primary,
  },
}));

export const PrintButton = styled(Button)({
  background: 'linear-gradient(to right, #0CBBDD, #10B981)',
  color: '#ffffff',
  '&:hover': {
    background: 'linear-gradient(to right, #0891b2, #059669)',
  },
});
